import { ColorHelperIcon } from './ColorHelperIcon';

/**
 * author: Google
 * id F27490D2-F7BE-4B35-83E6-40D1F7247755
 * name color-helper
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/color-helper.svg
 * tags
 * - Text / Content / Format 
 * - Color 
 */
export const ColourHelperIcon = ColorHelperIcon;
export default ColourHelperIcon